import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  loading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    // Fetch Profile
    fetchProfileStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchProfileSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    fetchProfileFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateProfileStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateProfileSuccess(state, action) {
      state.loading = false;
      state.user = { ...state.user, ...action.payload };
      state.error = null;
    },
    updateProfileFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // Edit Profile (optional, for future use)

    // Reset Profile (if needed)
    resetProfile(state) {
      state.user = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
  resetProfile,
} = profileSlice.actions;

export default profileSlice.reducer;
